// extracted by mini-css-extract-plugin
export var container = "_3m-0";
export var error = "_3m-9";
export var label = "_3m-5";
export var light = "_3m-6";
export var md = "_3m-3";
export var sm = "_3m-2";
export var thin = "_3m-8";
export var thinBold = "_3m-7";
export var vertical = "_3m-4";
export var xs = "_3m-1";